import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";

import { ErCrudModel } from "./ErCrudModel";

export class Specialty extends ErCrudModel {
  protected static _typeLabel = "Specialty";
  protected static _typeLabelPlural = "Specialties";
  protected static asProperty = "specialty";
  public static api = {
    path: "specialties",
    fullCache: true,
  };
  protected static routeBase = "specialties";
  protected static userPermissions = new UserPermissions(
    {
      [UserRole.SuperAdmin]: UserPermission.Edit,
      [UserRole.EntityOwner]: UserPermission.Edit,
      [UserRole.LoggedIn]: UserPermission.New,
    },
    UserPermission.Read
  );

  protected userIdField = [];

  protected static propertyDefinitions = [
    {
      type: "NumberProperty",
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "created_at",
        label: "Entry Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "updated_at",
        label: "Entry Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "DateTimeProperty",
      opts: {
        name: "deleted_at",
        label: "Entry Deleted At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: "StringProperty",
      opts: {
        name: "label",
        label: "Label",
        rules: ["required"],
      },
    },
    {
      type: "RelationshipPropertyMany",
      opts: {
        name: "sub_specialties",
        label: "Subspecialties",
        relatedModel: "SubSpecialty",
        foreignProperty: "specialty",
      },
    },
    // {
    //   type: "RelationshipPropertyMany",
    //   opts: {
    //     name: "experts",
    //     label: "Experts",
    //     relatedModel: "Expert",
    //     foreignProperty: "specialties",
    //   },
    // },
    {
      type: "RelationshipPropertyMany",
      opts: {
        name: "submissions",
        label: "Case Submissions",
        relatedModel: "Submission",
        foreignProperty: "specialty",
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: "NumberField", opts: { property: "id" } },
    {
      type: "DateTimeField",
      opts: { property: "created_at" },
    },
    { type: "DateTimeField", opts: { property: "updated_at" } },
    { type: "DateTimeField", opts: { property: "deleted_at" } },
    {
      type: "StringField",
      opts: { property: "label", isPrimaryLabelField: true },
    },
    // {
    //   type: "RelationshipFieldMany",
    //   opts: {
    //     property: "experts",
    //     viewComponentName: "form-relationship-field-many-table",
    //     formComponentName: "form-relationship-field-many-table",
    //     userPermissions: UserPermission.Read,
    //   },
    // },
    {
      type: "RelationshipFieldMany",
      opts: {
        property: "submissions",
        viewComponentName: "form-relationship-field-many-table",
        formComponentName: "form-relationship-field-many-table",
        userPermissions: UserPermission.Read,
      },
    },
    {
      type: "RelationshipFieldMany",
      opts: {
        property: "sub_specialties",
      },
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "TabbedModelLayout",
      opts: {
        id: "admin",
        tabs: [
          {
            id: "overviewTab",
            label: "Overview",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                id: "Crudform",
                fieldSets: [
                  {
                    id: "0",
                    fields: ["label", "sub_specialties"],
                  },
                  {
                    id: "meta",
                    fields: ["created_at", "updated_at", "id"],
                  },
                ],
              },
            },
          },

          // {
          //   id: "expertTab",
          //   label: "Experts",
          //   content: {
          //     type: "FieldSetGridLayout",
          //     opts: {
          //       id: "Crudform",
          //       fieldSets: [
          //         {
          //           id: "experts",
          //           fields: ["experts"],
          //         },
          //       ],
          //     },
          //   },
          // },

          {
            id: "submissionTab",
            label: "Submissions",
            content: {
              type: "FieldSetGridLayout",
              opts: {
                id: "Crudform",
                fieldSets: [
                  {
                    id: "notif",
                    fields: ["submissions"],
                  },
                ],
              },
            },
          },
        ],
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["label", "sub_specialties"],
      enableSearch: false,
      enableDynamicFilters: false,
      useDynamicFields: true,
      // dynamicFilterOptions: {
      //   filterFields: ["label", "content"],
      // },
      defaultSort: [
        {
          field: "label",
          order: "asc",
        },
      ],
    },
  ];
}
